import cx from 'classnames';
import { h } from 'preact';

import context from 'Data/text.json';

import { DEMOCRAT, NEUTRAL, REPUBLICAN, TIE } from '../colors';

function MapText({typeMap}) {
  return (
    <div class="results-map__text">
      {typeMap == 'categorical' && (
        <div class="results-map__legend">
         <div class="results-map__legend-item">
         {/* <span class="circle-pill" style={{ backgroundColor: TIE }} />{' '}
         <p class="results-map__legend-label">Tied</p> */}
       </div>
       <div class="results-map__legend-item">
         {/* <span class="circle-pill" style={{ backgroundColor: NEUTRAL }} />{' '}
         <p class="results-map__legend-label">No votes yet</p> */}
       </div>
       </div>
        )}
       {typeMap == 'bubble' && (
        <div class="results-map__notes">
         <span class="font-weight-bold">Note:</span> {context.bubble_map_text}
       </div>
        )}
  </div>  
    
  );
}

export default MapText;
